{
    "en": {
        "issue": "Key",
        "summary": "Summary",
        "project": "Project",
        "issueType": "Type",
        "priority": "Priority",
        "status": "Status"
    },
    "de": {
        "issue": "Key",
        "summary": "Zusammenfassung",
        "project": "Projekt",
        "issueType": "Type",
        "priority": "Priorität",
        "status": "Status"
    },
    "sv": {
        "issue": "ID",
        "summary": "Sammanfattning",
        "project": "Projekt",
        "issueType": "Ärendetyp",
        "priority": "Prioritet",
        "status": "Status"
    },
    "ro": {
        "issue": "ID",
        "summary": "Rezumat",
        "project": "Proiect",
        "issueType": "Tip problemă",
        "priority": "Prioritate",
        "status": "Stare"
    },
    "pl": {
        "issue": "Klucz",
        "summary": "Podsumowanie",
        "project": "Projekt",
        "issueType": "Typ",
        "priority": "Priorytet",
        "status": "Status"
    },
    "it": {
        "issue": "Chiave",
        "summary": "Sommario",
        "project": "Progetto",
        "issueType": "Tipo",
        "priority": "Priorità",
        "status": "Stato"
    },
    "nl": {
        "issue": "Sleutel",
        "summary": "Samenvatting",
        "project": "Project",
        "issueType": "Type",
        "priority": "Prioriteit",
        "status": "Status"
    },
    "hu": {
        "issue": "Kulcs",
        "summary": "Összegzés",
        "project": "Projekt",
        "issueType": "Típus",
        "priority": "Prioritás",
        "status": "Állapot"
    },
    "cz": {
        "issue": "Klíč",
        "summary": "Shrnutí",
        "project": "Projekt",
        "issueType": "Typ",
        "priority": "Priorita",
        "status": "Stav"
    }
}
